import { render, staticRenderFns } from "./solution4.vue?vue&type=template&id=200b16ff&scoped=true"
import script from "./solution4.vue?vue&type=script&lang=js"
export * from "./solution4.vue?vue&type=script&lang=js"
import style0 from "./solution4.vue?vue&type=style&index=0&id=200b16ff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200b16ff",
  null
  
)

export default component.exports